import React, {useRef, useState} from 'react';
import "./AddEmployeeForm.css";
import EmployeeManager from "./EmployeeManager";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";

const AddEmployeeForm = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState(''); // 'success' or 'error'
    const [showAlert, setShowAlert] = useState(false)
    const [fileName, setFileName] = useState('');
    const [fileURL, setFileURL] = useState('');
    const fileInputRef = useRef(null);
    const [updateKey, setUpdateKey] = useState(0);
    const [formData, setFormData] = useState({
        fullName: '',
        position: '',
        desctiprion: '',
        fullNameEng: '',  // New field
        positionEng: '',  // New field
        desctiprionEng: '',  // New field
        file: {
            base64String: '',
            ext: ''
        },
    });
    const resetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    const resetForm = () => {
        setFormData({
            fullName: '',
            position: '',
            desctiprion: '',
            fullNameEng: '',  // Reset new field
            positionEng: '',  // Reset new field
            desctiprionEng: '',  // Reset new field
            file: {
                base64String: '',
                ext: ''
            },
        });
        setFileName('');
        setFileURL('');
    };

    const handleInputChange = (e) => {
        if (e.target.name === 'file') {
            handleFileChange(e);
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };
    const isFormComplete = () => {
        return formData.fullName.trim() !== '' &&
            formData.position.trim() !== '' &&
            formData.desctiprion.trim() !== '' &&
            formData.fullNameEng.trim() !== '' &&  // Check new field
            formData.positionEng.trim() !== '' &&  // Check new field
            formData.desctiprionEng.trim() !== '' &&  // Check new field
            fileName !== '';
    };



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData({
                    ...formData,
                    file: {
                        base64String: reader.result.split(',')[1], // Remove the data URL part
                        ext: file.name.split('.').pop(),
                    }
                });
            };
            reader.readAsDataURL(file);

            setFileName(file.name);
            setFileURL(URL.createObjectURL(file));
        } else {
            alert('არაწორი ფორმატი');
        }
    };


    const handleDeleteImage = () => {
        setFileName('');
        setFileURL('');
        setFormData({ ...formData, file: { base64String: '', ext: '' } });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const handleConfirm = async () => {
        setIsModalOpen(false);

        // Extract the JWT token
        const jwtToken = localStorage.getItem('jwtToken');
        if (!jwtToken) {
            setAlertMessage('JWT Token is missing');
            setAlertType('error');
            setShowAlert(true);
            return;
        }


        try {
            // Make the POST request to the server
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/AddEmployee`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwtToken}`
                },
                body: JSON.stringify(formData)
            });

            // Handling the response
            if (response.ok) {
                setUpdateKey(prev => prev + 1);
                resetFileInput();
                const result = await response.json();
                resetForm();
                setAlertMessage('თანამშრომელი დაემატა წარმატებით');
                setAlertType('success');
            } else {
                setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგივანებით');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error submitting form');
            setAlertType('error');
        }
        setShowAlert(true);
    };

    return (

        <div className="employee-form-wrapper">
            <h1 className="employee-form-title">თანამშრომლის დამატება</h1>
            <form onSubmit={handleSubmit} className="employee-form">
                <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="სახელი"
                    className="employee-input"
                />
                <input
                    type="text"
                    name="position"
                    value={formData.position}
                    onChange={handleInputChange}
                    placeholder="თანამდებობა"
                    className="employee-input"
                />
                <input
                    name="desctiprion"
                    value={formData.desctiprion}
                    onChange={handleInputChange}
                    placeholder="კომპანია"
                    className="employee-input"
                />
                <input
                    type="text"
                    name="fullNameEng"
                    value={formData.fullNameEng}
                    onChange={handleInputChange}
                    placeholder="სახელი (ინგლისურად)"
                    className="employee-input"
                />
                <input
                    type="text"
                    name="positionEng"
                    value={formData.positionEng}
                    onChange={handleInputChange}
                    placeholder="თანამდებობა (ინგლისურად)"
                    className="employee-input"
                />
                <input
                    type="text"
                    name="desctiprionEng"
                    value={formData.desctiprionEng}
                    onChange={handleInputChange}
                    placeholder="კომპანია (ინგლისურად)"
                    className="employee-input"
                />
                <label htmlFor="file-upload" className="custom-file-upload">
                    {fileName || 'სურათის ატვირთვა (png, jpg)'}
                </label>
                {fileName && (
                    <>
                        <a href={fileURL} target="_blank" rel="noopener noreferrer" className="file-preview-link">
                            სურათის ნახვა
                        </a>
                        <button onClick={handleDeleteImage} className="delete-image-button">
                            სურათის წაშლა
                        </button>
                    </>
                )}

                <input
                    ref={fileInputRef}
                    id="file-upload"
                    type="file"
                    name="file"
                    onChange={handleInputChange}
                    accept=".png,.jpg"
                    className="employee-file-input"
                />
                <button type="submit" className="employee-submit-button" disabled={!isFormComplete()}>
                    თანამშრომლის დამატება
                </button>
            </form>
            <h1 className="employee-form-title">თანამშრომლის წაშლა</h1>

            <EmployeeManager updateKey={updateKey}/>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleConfirm}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    );
};

export default AddEmployeeForm;
